import Push from 'push.js';

import { NotificationType } from '../enums';

/** Push.js rejects denied/dismissed permission with a string; only that expected refusal is ignored. */
export const sendNotification = async (pendingReq: number, type: NotificationType) => {
  if (Push.Permission.get() === Push.Permission.DENIED) return;

  try {
    await Push.create(`${type} Request`, {
      body:
        type === NotificationType.shortage
          ? `There has been ${pendingReq} shortage/s reported`
          : type === NotificationType.lockTimeChange
            ? `There has been ${pendingReq} request/s to swap a meal`
            : `There has been ${pendingReq} request/s to modify a delivery`,
      icon: '/favicon.ico',
      vibrate: true,
      requireInteraction: true
    });
  } catch (error) {
    if (error !== 'PushError: permission request declined') throw error;
  }
};
